import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  useGetDialogsQuery,
  usePostDialogMutation,
} from "../../dialogs/dialogsSlice";

const useProblemCard = () => {
  const dialogs = useGetDialogsQuery();
  const [newDialogMutation] = usePostDialogMutation();
  const [creatingDialog, setCreatingDialog] = useState();
  const [topic, setTopic] = useState();
  const navigate = useNavigate();

  const postNewDialog = async () => {
    let result;
    try {
      setCreatingDialog(true);
      result = await newDialogMutation({
        body: { topic },
      });
      if (result?.data?.dialog_id) {
        navigate(`problems/${result?.data?.dialog_id}`);
      }
      setCreatingDialog(false);
    } catch (err) {
      console.error(err);
      setCreatingDialog(false);
    }
  };

  const handleNewDialog = () => {
    postNewDialog();
  };

  useEffect(() => {
    setTopic("AUTO");
    // eslint-disable-next-line
  }, []);

  const dialogsArray = dialogs?.data || [];
  const reversedArray = [...dialogsArray]
    ?.filter((item) => {
      return item.topic !== "AUTO" && item.topic !== "Solve the next problem";
    })
    .reverse();

  return {
    onCreateDialog: handleNewDialog,
    buttonCaption: "Solve the next problem",
    creatingDialog,
    dialogs: reversedArray,
    dialogsLoading: dialogs?.isLoading,
  };
};

export default useProblemCard;
